import { computed, createApp } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { ref } from 'vue-demi'

(function () {
  // Friendly Captcha zeitversetzt laden und damit aktivieren
  const targetClass = 'frc-captcha'
  const checkForClass = () => {
    if (document.querySelector(`.${targetClass}`)) {
      const jspath = document.querySelector('.friendly-captcha-js-path').dataset.src
      const script = document.createElement('script')
      script.src = jspath // Pfad zur JavaScript-Datei
      script.onload = () => console.log('Friendly Captcha erfolgreich geladen.')
      document.head.appendChild(script) // Script in den <head> einfügen
      clearInterval(intervalId)
    }
  }
  const intervalId = setInterval(checkForClass, 500)

  const appContainerSelector = '.company-contact-service .vue-app'

  if (!document.querySelector(appContainerSelector)) {
    return
  }

  const strings = {
    required: 'Bitte füllen Sie dieses Feld aus.',
    dateTimeRequired: 'Bitte wählen Sie ein Datum und eine Uhrzeit aus.'
  }

  const app = createApp({
    setup () {
      // const currentDate = new Date()

      const form = ref({
        bbnr: '',
        anfrage: '',
        kontaktname: '',
        kontakttelefon: ''
      })

      const submitted = ref(false)
      const errorMessage = ref('')
      const loading = ref(false)
      const v$ = useVuelidate()

      const getMaxSubjectLength = () => 1800

      const submitForm = async () => {
        v$.value.$touch()

        if (v$.value.$invalid) {
          return
        }

        loading.value = true

        const formData = {
          bbnr: form.value.bbnr,
          anfrage: form.value.anfrage,
          kontaktname: form.value.kontaktname,
          kontakttelefon: form.value.kontakttelefon
        }

        // set friendly captcha result
        formData.solution = document.querySelector('input[name="frc-captcha-response"]').value

        console.debug('formData', formData)

        const url = '/?type=1500000005'
        const options = {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          body: JSON.stringify(formData)
        }

        const response = await window.fetch(url, options)
        loading.value = false
        submitted.value = true
        if (response.ok) {
          const data = await response.json()

          console.debug('Success', data)

          // redirect to success page
          window.location.href = data.targetPageUrl
        } else {
          const data = await response.json()
          errorMessage.value = data.message
        }
      }

      const reset = () => {
        errorMessage.value = ''
        v$.value.$reset()
        submitted.value = false
        loading.value = false
      }

      const buttonLabel = computed(() => {
        return loading.value ? 'Formulardaten werden gesendet...' : 'Absenden'
      })

      const buttonDisabled = computed(() => {
        return loading.value
      })

      return {
        form,
        submitted,
        errorMessage,
        loading,
        v$,
        getMaxSubjectLength,
        submitForm,
        reset,
        buttonLabel,
        buttonDisabled
      }
    },
    validations () {
      return {
        form: {
          bbnr: {
            validBbnr: helpers.withMessage('Bitte geben Sie Ihre Betriebsnummer 8-stellig im Format 12345678 ein.',
              val => !val || /^\d{8}$/.test(val)
            )
          },
          anfrage: {
            required: helpers.withMessage(strings.required, required),
            maxLength: helpers.withMessage(() => 'Bitte geben Sie maximal ' + this.getMaxSubjectLength() + ' Zeichen ein.',
              (val, form) => {
                return val.length <= this.getMaxSubjectLength()
              })
          }
        }
      }
    },
    template: `
      <form class="callback-service__form form" @submit.prevent="submitForm">
        <div class="form-group">
          <label for="input-bbnr" class="form__label">Betriebsnummer<span
              class="form__mandatory">*</span></label>
          <input class="form__input"
                 inputmode="text"
                 type="text"
                 name="bbnr"
                 v-model="form.bbnr"
                 id="input-bbnr"
                 required
          />
          <ul v-if="v$.form.bbnr.$errors.length" class="errors">
            <li v-for="error in v$.form.bbnr.$errors">{{ error.$message }}</li>
          </ul>
        </div>

        <div class="form-group">
          <label for="input-kontaktname" class="form__label">Kontakt Name</label>
          <input class="form__input"
                 inputmode="text"
                 type="text"
                 name="kontaktname"
                 v-model="form.kontaktname"
                 id="input-kontaktname"
                 required
          />
        </div>

        <div class="form-group">
          <label for="input-kontakttelefon" class="form__label">Kontakt Telefon</label>
          <input class="form__input"
                 inputmode="text"
                 type="text"
                 name="kontakttelefon"
                 v-model="form.kontakttelefon"
                 id="input-kontakttelefon"
                 required
          />
        </div>

        <div class="form-group">
          <label for="input-anfrage" class="form__label">Anfrage<span
              class="form__mandatory">*</span></label>
          <textarea class="form__textarea"
                  inputmode="text"
                  name="anfrage"
                  v-model="form.anfrage"
                  id="input-anfrage"
                  required
          ></textarea>
          <ul v-if="v$.form.anfrage.$errors.length" class="errors">
            <li v-for="error in v$.form.anfrage.$errors">{{ error.$message }}</li>
          </ul>
        </div>
         
        <div class="form-group">
          <p>Die datenschutzrechtlichen Hinweise und Informationen zur Verarbeitung Ihrer Daten finden Sie auf unserer
            Webseite unter <a href="/datenschutz" target="_blank">www.bkkgs.de/datenschutz</a>.
          </p>
        </div>

        <div class="form-group">
          <div class="frc-captcha" data-sitekey="FCMLBQQMMTRE4TE7" data-lang="de" data-puzzle-endpoint="https://eu-api.friendlycaptcha.eu/api/v1/puzzle"></div>
        </div>

        <div class="button-container text--right">
          <button type="submit" class="btn btn--secondary" :disabled="buttonDisabled">{{ buttonLabel }}</button>
        </div>
      </form>

      <div ref="resultContainer" class="companycontact-service__output">

        <Transition name="callback-service" class="companycontact-service__error">
          <p v-if="submitted && errorMessage !== ''">
            {{ errorMessage }}
          </p>
        </Transition>
      </div>
    `
  })
  app.mount(appContainerSelector)
})()
